import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from 'utils/base-query';
import { getUserAccessToken } from 'utils/localstorage.helper';

// Define a service using a base URL and expected endpoints
export const accountApi = createApi({
  reducerPath: 'accountApi',
  tagTypes: ['Account'],
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getAccounts: builder.mutation({
      query: (queryParams) => {
        return {
          method: 'GET',
          url: `/accounts/me`,
          params: queryParams,
          headers: {
            authorization: `Bearer ${getUserAccessToken()}`
          }
        };
      }
    }),
    updateAccount: builder.mutation({
      query: ({ id, data }) => {
        return {
          method: 'PUT',
          url: `/accounts/${id}`,
          body: data,
          headers: {
            authorization: `Bearer ${getUserAccessToken()}`
          }
        };
      }
    }),
    enableWarmup: builder.mutation({
      query: ({ id }) => {
        return {
          method: 'PUT',
          url: `accounts/${id}/warmup/enable`,
          headers: {
            authorization: `Bearer ${getUserAccessToken()}`
          }
        };
      }
    }),
    pauseWarmup: builder.mutation({
      query: ({ id }) => {
        return {
          method: 'PUT',
          url: `accounts/${id}/warmup/pause`,
          headers: {
            authorization: `Bearer ${getUserAccessToken()}`
          }
        };
      }
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetAccountsMutation, useUpdateAccountMutation, useEnableWarmupMutation, usePauseWarmupMutation } = accountApi;
